// extracted by mini-css-extract-plugin
export default {"productGallery":"TN-z","inQuickShop":"UN-z"};